import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { PENDING_VISITOR_LIST_API } from '../utils/api';

function VisitorApproval() {
  const [visitors, setVisitors] = useState([]);
  const navigate = useNavigate();

  const token = localStorage.getItem('token');
  const decoded = JSON.parse(atob(token));
  const customer_id = decoded.customer_id;
  const client_user_id = decoded.id;

  useEffect(() => {
    fetchPendingVisitors();
  }, []);

  const fetchPendingVisitors = async () => {
    try {
      const res = await axios.post(PENDING_VISITOR_LIST_API, {
        customer_id,
        client_user_id,
        token
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        setVisitors(res.data.visitors || []);
      } else {
        toast.error(res.data.message || 'Failed to fetch visitors');
      }
    } catch (err) {
      toast.error('Server error');
    }
  };

 const handleApproveClick = (visitor_id, created_at) => {
  const encodedId = encodeURIComponent(visitor_id);
  const encodedTimestamp = encodeURIComponent(created_at);
  navigate(`/visitor-approval/confirm?id=${encodedId}&timestamp=${encodedTimestamp}`);
};
  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>🕒 Pending Visitor Approvals</h4>
          <span className="badge bg-primary fs-6">
            Total Visitors: {visitors.length}
          </span>
        </div>

        {visitors.length === 0 ? (
          <p>No visitors pending approval.</p>
        ) : (
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Photo</th>

                <th>Name</th>
                <th>Company</th>
                <th>Mobile</th>
                <th>Sex</th>
                <th>DOB</th>
                <th>Visitor Type</th>
                <th>Purpose</th>
                <th>Department</th>
                <th>Whom to Visit</th>
                <th>Entered By</th>
                <th>Action</th> {/* 👈 Added */}
              </tr>
            </thead>
            <tbody>
              {visitors.map((visitor, index) => (
                <tr key={visitor.id}>
                  <td>{index + 1}</td>
                  <td>
  {visitor.visitor_photo ? (
    <img
      src={`data:image/jpeg;base64,${visitor.visitor_photo}`}
      alt="Visitor"
      width={150}
      height={150}
      style={{ objectFit: 'cover', borderRadius: '4px' }}
    />
  ) : (
    'No Photo'
  )}
</td>

                  <td>{visitor.name}</td>
                  <td>{visitor.company}</td>
                  <td>{visitor.mobile}</td>
                  <td>{visitor.sex}</td>
                  <td>{visitor.birth_date}</td>
                  <td>{visitor.visitor_type_name}</td>
                  <td>{visitor.visit_purpose_name}</td>
                  <td>{visitor.department_name}</td>
                  <td>{visitor.whom_to_visit_name}</td>
                  <td>{visitor.created_by_name || '-'} <br/> { visitor.created_at}</td>

                  <td>
  {visitor.approval_status === 'Pending' ? (
    <button
      className="btn btn-warning btn-sm"
      onClick={() => handleApproveClick(visitor.id, visitor.created_at)}
    >
      Approve
    </button>
  ) : (
    <span className={`badge bg-${visitor.approval_status === 'Approved' ? 'success' : 'danger'}`}>
      {visitor.approval_status}
    </span>
  )}
</td>

                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

export default VisitorApproval;
